/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M112.5 28.125c0-.828-.328-1.625-.914-2.21a3.128 3.128 0 0 0-2.211-.915h-68.75a3.124 3.124 0 0 0-3.125 3.125v93.75c0 .828.328 1.625.914 2.21a3.128 3.128 0 0 0 2.211.915h50a3.123 3.123 0 0 0 2.371-1.094l18.75-21.875c.219-.258.39-.554.512-.867.039-.098.055-.2.086-.312h.004c.066-.227.105-.457.12-.688 0-.059.032-.117.032-.176V28.125zM43.75 31.25h62.5v65.625H90.625A3.124 3.124 0 0 0 87.5 100v18.75H43.75v-87.5zm50 71.875h8.832l-8.832 10.312v-10.312z"/><path pid="1" d="M53.125 43.75h43.75V50h-43.75zM53.125 56.25h43.75v6.25h-43.75zM53.125 68.75h43.75V75h-43.75zM53.125 81.25H81.25v6.25H53.125z"/></g>'
  }
})
